import { Component, OnInit, ViewChild } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { CanonicalService } from '../../shared/canonical.service';
declare var jQuery: any;
import * as AWS from "aws-sdk";
import { DomSanitizer } from '@angular/platform-browser';

function ValidateEmail(control:AbstractControl):{[key:string]:Boolean}|null{  
      
  // let regularExp = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo|outlook)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
  let regularExp = /^([\w.-]+)@((?!hotmail|gmail|yahoo|outlook)([a-zA-Z\d-]+\.)+)([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
    
      if(control.value!==undefined && !regularExp.test(control.value)){  
        return {"isValidEmail":true};  
      }  
      return null;  
  } 

@Component({
  selector: 'app-appbindlanding',
  templateUrl: './appbindlanding.component.html',
  styleUrls: ['./appbindlanding.component.css']
})
export class AppbindlandingComponent implements OnInit {

  @ViewChild('closebutton') closebutton: any;
  subscribeForm: FormGroup;
  demoForm: FormGroup;
  public message: any;
  cilentIPAddress = '';
  demoSubmitted = false;
  submittedSub = false;
  innerWidth:number = window.innerWidth;
  currentRoutePath: any;
  heading = "Zero Trust DEVICE & SIM Binding Solution";
  subheading = "Talk to us for a detailed demo to ensure a safe & secure mobile app experience";

  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta,public fb: FormBuilder, private http: HttpClient,private httpService: HttpService, private canonicalService: CanonicalService, public router: Router, private domSanitizer: DomSanitizer) { 
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/appbind");
    this.currentRoutePath = this.router.url;
    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });

    this.subscribeForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
      //email: [''],
    });
    this.demoForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern('^[A-Za-z ]+$')])],
      designation: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      message: [''],
      contactnumber: ['', Validators.compose([Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])],
      company_name: ['', Validators.compose([Validators.required])]
      //email: [''],
     
    });
  }

  s3: any;
  videoUrl: string = '';
  ngOnInit(): void {
    this.titleService.setTitle('Safe & Secure Mobile App Security for Banking and Financial Apps | Protectt.ai');
    this.metaTagService1.updateTag({name: 'title', content: 'Safe & Secure Mobile App Security for Banking and Financial Apps | Protectt.ai'});
    this.metaTagService.updateTag({ name: 'description', content: 'We offer the most secure and advanced mobile security for banking applications. We used LSAP technology to detect fraud, safeguarding the app from online banking fraud. Zero Trust Device Binding for Mobile Banking Apps.'});
    
    var that = this;
    $('#playLandingVideo').on('hidden.bs.modal', function (e) {
      that.videoUrl = '';
    })
  }

  onClickPdfView(filename: any) {
    let AKey;
    let SKey;
    let url = environment.API_URL + "fetchbucketcred"
    this.httpService.getAPI(url).then((resp: any) => {
      // console.log(resp);
      let decRes = this.httpService.decryptText(resp, HttpService.SECRET_KEY);
      let decMsg = JSON.parse(decRes);
      // console.log(decMsg?.lkpList);
      // console.log(decMsg?.lkpList[0].lkpvalue);
      // console.log(decMsg?.lkpList[1].lkpvalue);

      AKey = decMsg?.lkpList[0].lkpvalue;
      SKey = decMsg?.lkpList[1].lkpvalue;


      AWS.config.update({
        accessKeyId: AKey,
        secretAccessKey: SKey,
        region: "ap-south-1",
      });
      this.s3 = new AWS.S3();
      // console.log(this.s3);

      // console.log(filename)
      setTimeout(() => {
        let logo = "datasheets/" + filename;

        // console.log(logo)
        const url = this.s3.getSignedUrl("getObject", {
          Bucket: environment.Bucket,
          Key: filename,
          Expires: 600,
        });
        // console.log(url);
        this.videoUrl = url || '';
        //window.open(this.pdfPath, "_blank");
      }, 500);

    })
  }

  submitDemoForm() {
    let url = environment.API_URL + "requestdemo";
    let urlValue = "";
    this.demoSubmitted = true;
    if (this.demoForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      var demoData = {
        email: this.demoForm.get('email')!.value,
        name: this.demoForm.get('name')!.value,
        designation: this.demoForm.get('designation')!.value,
        message: this.demoForm.get('message')!.value,
        contactnumber: this.demoForm.get('contactnumber')!.value,
        companyname: this.demoForm.get('company_name')!.value,
        ipaddress: this.cilentIPAddress,
        weburl: urlValue,
        adcampurl: this.currentRoutePath
      };
      let data = {
        salesLeadData: demoData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }

      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          let resp: any = JSON.parse(decMsg);
          alert(resp['statusDesc']);
          // this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });

      this.demoSubmitted = false;
      // alert("Request has been submitted..");
      this.closebutton.nativeElement.click();
      this.router.navigateByUrl("/appbindthankyou");
    }
  }

  onReset() {

    this.message = '';
    this.demoForm.reset();
    this.subscribeForm.reset();
    this.demoSubmitted = false;
    this.submittedSub = false;
  }

  get getDemoForm() {
    return this.demoForm.controls;
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

  myFunction(btnid: any) {
    var elem = jQuery("#" + btnid + "-btn")[0].innerHTML;
    if (elem == "Read More ↓") {
      jQuery("#" + btnid + "-btn")[0].innerHTML = "Read Less ↑";
      jQuery("." + btnid).slideDown();
      jQuery('.' + btnid + '.dots').hide();
    } else {
      jQuery("#" + btnid + "-btn")[0].innerHTML = "Read More ↓";
      jQuery("." + btnid).slideUp();
      jQuery('.' + btnid + '.dots').show();
    }
  }

  goto(set?: any) {
    var htmlElement = document.getElementById('targetcontact');
    var elementPosition = htmlElement?.getBoundingClientRect().top || 0;
    if (set == 1) {
      window.scrollTo({
        top: elementPosition + window.pageYOffset - 60,
        behavior: 'smooth'
      })
    } else {
      window.scrollTo({
        top: elementPosition + window.pageYOffset - 160,
        behavior: 'smooth'
      })
    }
  }

  getMainContentTrusted(value: any) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
  }

}
